import { render, staticRenderFns } from "./ActivityFormPage.vue?vue&type=template&id=3a763162"
import script from "./ActivityFormPage.vue?vue&type=script&lang=js"
export * from "./ActivityFormPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports